module.exports = __webpack_public_path__ + "img/smiley R.f45ccaef.svg";